module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/mario-cordova-9c4fa49e8e5564a26cd80352c8d2aeda.webp";